export const name = 'sessionManager' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'

export const SessionManagerSymbol = Symbol('SessionManager')
export const DynamicModelSessionProviderSymbol = Symbol('DynamicModelSessionProvider')
export const AuthorizationCodeRefreshSymbol = Symbol('AuthorizationCodeRefresh')

export const sessionExportsNamespace = 'session'
